import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import AdminMenu from "../../AdminMenu";
import { getFranchise } from "../../../services/FranchiseModal/Franchise";
import FinanceAdminMenu from "../../FinanceAdminMenu";

const FranchiseManagementList = () => {
  const navigate = useNavigate();

  const [franchiseInfoData, setFranchiseInfoData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);

  const fetchFranchise = () => {
    setLoading(true);
    getFranchise(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setFranchiseInfoData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchFranchise();
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const filterUserList = () => {
    return franchiseInfoData.filter((item) => {
      const fullName = item.name?.toLowerCase();
      const matchesSearchTerm = fullName?.includes(searchTerm.toLowerCase());
      return matchesSearchTerm;
    });
  };

  const filteredUserData = filterUserList();

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Name :
                  </p>
                  <p className="text-lg font-medium capitalize">{item.name}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.status}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/Franchise-Create", {
                        state: {
                          item: item,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                  <div
                    className="mr-4 mt-2 cursor-pointer"
                    onClick={
                      () =>
                        navigate("/franchise-config-list", {
                          state: {
                            franchiseItem: item,
                          },
                        })
                      // navigate("/Franchise-Store-Mapped-List", {
                      //   state: {
                      //     item: item,
                      //   },
                      // })
                    }
                  >
                    <img
                      src="Laundy_App_Icons_Gifs/Customer_Info_GIFs/Book_New_Order.gif"
                      alt="config"
                      style={{
                        width: 50,
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Email :
                  </p>
                  <p className="text-lg font-medium">{item.email}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Mobile :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.mobile}
                  </p>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Address :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item?.address?.fullAddress}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise List
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2 mx-5 flex flex-1">
        <div
          onClick={() =>
            navigate("/Franchise-Create", {
              state: {
                item: null,
              },
            })
          }
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
        >
          <div>
            <img
              src={
                "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"
              }
              style={{ width: 27 }}
            />
          </div>
        </div>
        <div className="flex-1">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={"Search Franchise"}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
        </div>

        <div
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          onClick={() => setSearchTerm("")}
        >
          <div>
            <p className="text-4xl font-bold " style={{ color: "red" }}>
              X
            </p>
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : franchiseInfoData?.length > 0 ? (
          <div>
            <div>{renderCardItem(filteredUserData || franchiseInfoData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Franchise Found</p>
          </div>
        )}
      </div>

      {userRole === "BY_ACCOUNTANT" ? (
        <FinanceAdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <AdminMenu setVisible={setVisible} visible={visible} />
      )}
    </div>
  );
};

export default FranchiseManagementList;
